export default class AvayaCallData {
    public phoneNumber: string;
    public time: string;
    public result: string;

    constructor(phoneNumber: string, time: string, result: string) {
        this.phoneNumber = phoneNumber;
        this.time = time;
        this.result = result;
    }
}